import { useState } from 'react';
import type { VisibilityState } from '@/lib/tanstack-table';
import {
  columnsHiddenByFilters,
  filterColumnVisibility,
  type ColumnHiddenByFilter,
  type FilterableColumn,
} from '../utils/columnsHiddenByFilters';

export interface HiddenColumns {
  /** Columns a filter narrowed to one value, shown again or not. */
  hiddenByFilters: ColumnHiddenByFilter[];
  /** The buyer asked to see these despite the filter (this visit only). */
  shownColumnIds: ReadonlySet<string>;
  toggleShown: (id: string) => void;
  /** The table's one visibility state for these columns. */
  columnVisibility: VisibilityState;
}

export function useColumnsHiddenByFilters<Row>(
  columns: readonly FilterableColumn<Row>[],
  rows: readonly Row[],
  options?: { complete?: boolean },
): HiddenColumns {
  const [shownColumnIds, setShownColumnIds] = useState<ReadonlySet<string>>(
    () => new Set(),
  );
  const toggleShown = (id: string) => {
    setShownColumnIds((prev) =>
      prev.has(id)
        ? new Set([...prev].filter((shown) => shown !== id))
        : new Set([...prev, id]),
    );
  };
  const hiddenByFilters = columnsHiddenByFilters(columns, rows, options);
  return {
    hiddenByFilters,
    shownColumnIds,
    toggleShown,
    columnVisibility: filterColumnVisibility(hiddenByFilters, shownColumnIds),
  };
}
